import { cloneDeep, get } from "lodash-es";
import React, { FC, ReactElement } from "react";

import { NativeSelect, OutlinedInput } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { capitalize } from "@mui/material/utils";

import useCurrentClusterSupportsSsh from "../../../../hooks/use-current-cluster-supports-ssh";
import criteriaJson from "../../../../json/ppl_criteria.json";
import { PplRule } from "../../../../store/pomeriumApi";
import { Criterion } from "@/utils/ppl";

interface CriteriaSelectProps {
  readonly: boolean;
  pplArr: any[];
  savePPL(ppl: PplRule[]): void;
  condition: "and" | "or" | "not" | "nor";
  blockIDX: number;
  allowDeny: "allow" | "deny";
  ruleIDX: number;
  criteria: string;
}

const CriteriaSelect: FC<React.PropsWithChildren<CriteriaSelectProps>> = ({
  readonly,
  pplArr,
  savePPL,
  condition,
  blockIDX,
  allowDeny,
  ruleIDX,
  criteria,
}: CriteriaSelectProps): ReactElement => {
  const supportsSsh = useCurrentClusterSupportsSsh();
  return (
    <FormControl variant="outlined" sx={{ width: `95%` }} margin="dense">
      <InputLabel htmlFor="outlined-criteria-native-simple">
        Criteria
      </InputLabel>
      <NativeSelect
        value={criteria.split("/")[0]}
        onChange={(evt) => {
          const arr = cloneDeep(pplArr);
          const value = evt.target.value.toString();
          arr[blockIDX][allowDeny][condition][ruleIDX] =
            Criterion.defaultForName(value).toValue();
          savePPL(arr);
        }}
        size="small"
        input={<OutlinedInput label="Criteria" />}
        inputProps={{
          name: "Criteria",
          id:
            "outlined-criteria-native-simple" +
            blockIDX +
            allowDeny +
            condition +
            ruleIDX,
        }}
        disabled={readonly}
      >
        {Object.keys(criteriaJson).map((critKey) => {
          if (critKey.includes("ssh") && !supportsSsh) {
            return null;
          }
          return (
            <option
              key={
                blockIDX +
                allowDeny +
                condition +
                ruleIDX +
                +"criteria" +
                critKey
              }
              value={critKey}
            >
              {capitalize(get(criteriaJson, critKey + ".name", ""))}
            </option>
          );
        })}
      </NativeSelect>
    </FormControl>
  );
};

export default CriteriaSelect;
